export default {
  title: "Баллдарды эсептөө",
  toSetDiffPercent:
    "Кардарлардын сатып алуу суммасына жараша ар кандай сыйлык % коюу үчүн «Промо» же «Про+» тарифин сатып алуу керек",
  areUSureToDeleteGroup: "Топту чын эле өчүргүңүз келеби?",
  userGetAwardDuring30Min:
    "Колдонуучу операция жүргүзүлгөндөн кийин 30 мүнөттүн ичинде сыйлыгын алат",
  creatingNewAndEditingNotAvailable:
    "Жаңы топ түзүү жана учурдагы топторду түзөтүү жеткиликтүү эмес",
  payAttention: "Көңүл буруңуз!",
  bannerText:
    "Бул функция сиз санарипке өткөргөн кардарлар үчүн гана иштейт. <br /><br /> Сиздин <b>санарипке өткөрүлгөн</b> кардарларыңыз топто көрсөтүлгөн пайыздын 50% сыйлык катары алышат (комиссия алынбайт). Сатып алуулар суммасы арзандатуу суммасын кошпой эсептелет.",
  seeRewardScenarios: "Сыйлык бөлүштүрүү сценарийлерин көрүү",
  createNewGroup: "Жаңы топ түзүү",

  tableHeaders: {
    groupNaming: "Топтун<br/>аты",
    pointNaming: "Соода<br/>жайынын аталышы",
    purchaseSum: "Сатып алуу<br/>суммасы",
    accrualPercent: "Эсептөө<br/>пайызы",
    status: "Статус",
  },
};
